import { Avatar } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";

export const ContactPerson = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.contact) {
    return null;
  }

  return (
    <div className="mt-3">
      <Item className="items-center" label={t`Contact person`}>
        <Avatar
          // TODO add hex_color after contact type is done on backend
          size="sm"
          src={store.invoice?.contact.image}
          name={store.invoice?.contact.full_name}
        />
        <span className="ml-4">{store.invoice?.contact.full_name}</span>
      </Item>
    </div>
  );
};
